import React from 'react'
import BlobIcon from '@/assets/icons/BlobIcon'

/**
 * EmptyState — centered icon + title + optional description/action, used as
 * the empty content of a list, dropdown, panel, etc.
 *
 * Defaults to the "We didn't predict this" message for search-style empty states.
 */
const EmptyState = ({
  icon = null,
  title = "We didn't predict this",
  description = 'Try a different search, or suggest a new market to us.',
  action = null,
  className = '',
}) => {
  return (
    <div
      className={
        'flex flex-col items-center justify-center w-full text-center py-6 ' + className
      }>
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-brand-1 mb-6 text-Neutral-5">
        {icon || <BlobIcon width="20px" />}
      </div>
      <p className="text-Neutral-6 font-bold text-xl leading-[133%] mb-2">{title}</p>
      {description && (
        <p
          className="text-Neutral-4 text-base leading-[150%]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}

export default EmptyState
